'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkSection.module.css';

export function DevlinkSection({ as: _Component = _Builtin.Section, sectionBody }) {
  return (
    <_Component
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
        {sectionBody}
      </_Builtin.Block>
    </_Component>
  );
}
